var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBilling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.617 7.60137H18.5106V6.55242C18.5106 5.33564 17.5957 4.32864 16.383 4.16081V2.88109C16.383 1.55941 15.2766 0.468506 13.9362 0.468506H2.59574C1.19149 0.468506 0.0212766 1.58039 0 2.98599V14.8391C0 16.1608 1.10638 17.2517 2.44681 17.2517H16.0638C17.4043 17.2517 18.5106 16.1608 18.5106 14.8391V13.6853H18.617C19.383 13.6853 20 13.0769 20 12.3217V8.96501C20 8.20976 19.383 7.60137 18.617 7.60137ZM1.48936 3.02795C1.48936 2.41955 2 1.93704 2.59574 1.93704H13.9149C14.4468 1.93704 14.8723 2.35662 14.8723 2.88109V4.13983H2.59574C2 4.13983 1.48936 3.63634 1.48936 3.02795ZM18.5106 12.2168H15C14.1277 12.2168 13.4043 11.5035 13.4043 10.6433C13.4043 9.78319 14.1277 9.0699 15 9.0699H18.5106V12.2168Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.a1b932a5.svg";
export { ForwardRef as ReactComponent };